import { render, staticRenderFns } from "./PrintBangKhachHang.vue?vue&type=template&id=7b0e3a26&"
import script from "./PrintBangKhachHang.vue?vue&type=script&lang=js&"
export * from "./PrintBangKhachHang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports